
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ModalHeader from '@/components/modal/ModalHeader.vue';

@Component({
    components: {
        ModalHeader,
    },
})
export default class CustomModal extends Vue {
    @Prop() id!: string;

    @Prop() title!: string;

    @Prop({ default: false, type: Boolean }) customFooter?: boolean;

    @Prop() buttonLanguageKey!: string;

    @Prop({ default: 'md', type: String }) size!: string;

    @Prop({ default: '', type: String }) bodyClass!: string;
    @Prop({ default: false, type: Boolean }) closeDisabled!: boolean;

    @Emit('close')
    onClose(): void {
        if (this.closeDisabled) {
            return;
        }

        this.$bvModal.hide(this.id);
    }

    @Emit('submit')
    onSubmit(): void {
        // submit
    }

    @Emit('on-hidden')
    onHidden(): void {
        this.onClose();
    }
}
